export const getSizedImagePath = function( path: string, size: string | number ){
  if( !path ) return;
  if( path.indexOf('.jpg?') >= 0 ){
    path = path.replace('.jpg?', '_' + size + '.jpg?');
  }else if( path.indexOf('.png?') >= 0 ) {
    path = path.replace('.png?', '_' + size + '.png?');
  }
  return path;
}

export const preloadImages = function( images: string[] ){
  for (let i = 0; i < images.length; i++) {
    const img = new Image;
    img.src = images[i];
  }
}

export const sleep = function (ms: number) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
}

//Manipulate Cookies
export const getCookie = function(name: string) {
  const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

export const setCookie = function(name: string, value: string, days: number) {
  const d = new Date();
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toUTCString();
}

export function debounce<Args extends unknown[]>(
  func: (...args: Args) => void,
  delay: number,
): (...args: Args) => void {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  return (...args: Args) => {
    if( timeoutId ) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
      timeoutId = null;
    }, delay);
  };
}

export const setElementValue = (el: Element | null, value?: string | number ) => {
  if( !(el instanceof HTMLInputElement )) return
  el.value = String(value)
}

export const setElementInnerHTML = (el: Element | null, value?: string ) => {
  if( !(el instanceof HTMLElement )) return
  el.innerHTML = value || ""
}

export const setElementInnerText = (el: Element | null, value?: string ) => {
  if( !(el instanceof HTMLElement )) return
  el.innerText = value || ""
}

export const setElementStyleAttribute = (el: Element | null, key: string, value: string ) => {
  if( !(el instanceof HTMLElement )) return
  el.style.setProperty(key, value)
}

export const removeElementStyleAttribute = (el: Element | null, key: string) => {
  if( !(el instanceof HTMLElement )) return
  el.style.removeProperty(key)
}

export const getSizedImageUrl = (url: string, size: string) => {
  const urlParts = url.split('.');
  const extension = urlParts.pop();
  const baseName = urlParts.join('.'); 
  const resizedUrl = `${baseName}_${size}.${extension}`;
  
  return resizedUrl;
};